module.exports = __webpack_public_path__ + "gp.png?7299997988f9ca5880af4208c00b86ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gp.png
// module id = 22
// module chunks = 0